import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./context/AuthContext";

// Layout
import MainLayout from "./layouts/MainLayout";
import DashboardLayout from "./layouts/DashboardLayout";

// Public Pages
import LandingPage from "./pages/LandingPage";
import WaitlistPage from "./pages/WaitlistPage";
import ExplorePage from "./pages/ExplorePage";
import EventsPage from "./pages/EventsPage";
import CalendarPage from "./pages/CalendarPage";
import MarketplacePage from "./pages/MarketplacePage";
import MembershipPage from "./pages/MembershipPage";
import MembershipSuccessPage from "./pages/MembershipSuccessPage";
import ProsCornerPage from "./pages/ProsCornerPage";
import HBCUPage from "./pages/HBCUPage";
import CityPage from "./pages/CityPage";
import CourseDetailPage from "./pages/CourseDetailPage";
import LeagueDetailPage from "./pages/LeagueDetailPage";
import EventDetailPage from "./pages/EventDetailPage";
import TravelGuidesPage from "./pages/TravelGuidesPage";
import TravelGuideDetailPage from "./pages/TravelGuideDetailPage";
import CourseMapPage from "./pages/CourseMapPage";
import MemberCardPage from "./pages/MemberCardPage";

// Auth Pages
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import OnboardingPage from "./pages/OnboardingPage";

// Member Pages
import DashboardPage from "./pages/DashboardPage";
import ProfilePage from "./pages/ProfilePage";
import MessagesPage from "./pages/MessagesPage";
import ChatsPage from "./pages/ChatsPage";
import TravelModePage from "./pages/TravelModePage";
import SocialFeedPage from "./pages/SocialFeedPage";
import NotificationPrefsPage from "./pages/NotificationPrefsPage";

// Rounds & Scoring
import RoundsPage from "./pages/RoundsPage";
import RoundDetailPage from "./pages/RoundDetailPage";
import CreateRoundPage from "./pages/CreateRoundPage";

// AI Concierge
import CaddiePage from "./pages/CaddiePage";

// Admin
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminPage from "./pages/AdminPage";

// Protected Route Component
import ProtectedRoute from "./components/ProtectedRoute";

// Floating AI Assistant
import CaddieWidget from "./components/CaddieWidget";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public Routes */}
          <Route element={<MainLayout />}>
            <Route path="/" element={<LandingPage />} />
            <Route path="/waitlist" element={<WaitlistPage />} />
            <Route path="/explore" element={<ExplorePage />} />
            <Route path="/events" element={<EventsPage />} />
            <Route path="/calendar" element={<CalendarPage />} />
            <Route path="/marketplace" element={<MarketplacePage />} />
            <Route path="/membership" element={<MembershipPage />} />
            <Route path="/membership/success" element={<MembershipSuccessPage />} />
            <Route path="/pros" element={<ProsCornerPage />} />
            <Route path="/hbcu" element={<HBCUPage />} />
            <Route path="/travel-guides" element={<TravelGuidesPage />} />
            <Route path="/travel-guides/:stateCode" element={<TravelGuideDetailPage />} />
            <Route path="/course-map" element={<CourseMapPage />} />
            <Route path="/member-card" element={<MemberCardPage />} />
            <Route path="/cities/:citySlug" element={<CityPage />} />
            <Route path="/courses/:courseId" element={<CourseDetailPage />} />
            <Route path="/leagues/:leagueId" element={<LeagueDetailPage />} />
            <Route path="/events/:eventId" element={<EventDetailPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
          </Route>

          {/* Protected Member Routes */}
          <Route element={<ProtectedRoute><DashboardLayout /></ProtectedRoute>}>
            <Route path="/onboarding" element={<OnboardingPage />} />
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/profile/:uid" element={<ProfilePage />} />
            <Route path="/messages" element={<MessagesPage />} />
            <Route path="/chats" element={<ChatsPage />} />
            <Route path="/travel" element={<TravelModePage />} />
            <Route path="/rounds" element={<RoundsPage />} />
            <Route path="/rounds/new" element={<CreateRoundPage />} />
            <Route path="/rounds/:roundId" element={<RoundDetailPage />} />
            <Route path="/caddie" element={<CaddiePage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/admin/*" element={<AdminDashboard />} />
          </Route>
        </Routes>
        <Toaster position="top-right" richColors />
        <CaddieWidget />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
